const quizData = {
  programming: [
    {
      question: "What does HTML stand for?",
      options: ["Hyper Text Markup Language", "High Tech Multi Language",
         "Hyper Transfer Markup Language", "None of the above"],
      correct: 0,
    },
    {
      question: "Which programming language is known as the 'mother of all languages'?",
      options: ["Assembly", "Java", "Python", "C"],
      correct: 3,
    },
    {
      question: "What is the purpose of CSS in web development?",
      options: ["To add interactivity", "To structure content", "To style and layout web pages",
         "To handle server-side logic"],
      correct: 2,
    },
    {
      question: "What does API stand for in programming?",
      options: ["Application Programming Interface", "Automated Program Instruction",
         "Advanced Programming Integration", "Application Process Integration"],
      correct: 0,
    },
    {
      question: "Which of the following is not a JavaScript data type?",
      options: ["Number", "String", "Boolean", "Character"],
      correct: 3,
    },
  ],
  sports: [
    {
      question: "Which country won the FIFA World Cup 2022?",
      options: ["Brazil", "Argentina", "France", "Germany"],
      correct: 1,
    },
    {
      question: "In which sport would you perform a slam dunk?",
      options: ["Volleyball", "Tennis", "Basketball", "Soccer"],
      correct: 2,
    },
    {
      question: "How many players are there in a standard soccer team on the field?",
      options: ["9", "10", "11", "12"],
      correct: 2,
    },
    {
      question: "Which Grand Slam tennis tournament is played on grass courts?",
      options: ["Australian Open", "French Open", "Wimbledon", "US Open"],
      correct: 2,
    },
    {
      question: "In which Olympic sport would you perform a vault?",
      options: ["Swimming", "Gymnastics", "Diving", "Track and Field"],
      correct: 1,
    },
  ],
};

export default quizData;